module.exports = __webpack_public_path__ + "static/media/carousel2.b7ac279f.png";